import { formatTestId } from "@nimble/ts-formatters/format-test-ids";

import { schoolStatsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

type SchoolDetailStudentCountProps = {
  schoolId: string;
  studentCount: number;
};

export default function SchoolDetailStudentCount({
  schoolId,
  studentCount,
}: SchoolDetailStudentCountProps) {
  return (
    <span
      className="flex items-center gap-1.5 text-xs sm:text-sm text-ink-emphasis font-medium"
      data-testid={`${schoolStatsTestIds.SCHOOL_STUDENT_COUNT}-${formatTestId(
        schoolId,
      )}`}
    >
      {studentCount.toLocaleString()} students
    </span>
  );
}
